import { TenantViewModel } from '@ail/customers-api'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetTenantsQuery } from '../../../../redux/api/customerApi'
import { useAuth } from '../../../../auth/useAuth'

export function TenantSelector() {
  const [search, setSearch] = useState('')
  const [impersonating, setImpersonating] = useState(false)
  const [itemsVisible, setItemsVisible] = useState(false)
  const inputRef = useRef<HTMLDivElement>(null)
  const { t } = useTranslation('common')
  const { user, impersonate } = useAuth()
  const tenants = useGetTenantsQuery()

  const currentTenant = useMemo(
    () => (user?.tenant ? tenants.data?.find((t) => t.id.toLowerCase() === user.tenant?.toLowerCase()) : undefined),
    [tenants.data, user?.tenant]
  )

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (!inputRef?.current?.contains(event.target as Node)) {
        setItemsVisible(false)
      }
    }

    if (itemsVisible) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [itemsVisible])

  const inputName = useMemo(() => Math.random().toString(36).slice(2, 18), [])

  const selectTenant = async (tenant?: TenantViewModel) => {
    setImpersonating(true)
    impersonate(tenant?.id.length ? tenant.id : undefined).finally(() => setImpersonating(false))
  }

  const loading = tenants.isFetching || impersonating
  const inputValue = loading ? '' : search ? search : currentTenant?.name ?? ''

  return (
    <div className="input-area small" ref={inputRef}>
      <input
        name={inputName}
        autoComplete="none"
        list="autocompleteOff"
        value={inputValue}
        onInput={(e) => setSearch(e.currentTarget.value)}
        style={{ maxWidth: '150px' }}
        placeholder={loading ? `${t('LOADING')}...` : t('ALL')}
        className="transparent"
        onClick={() => setItemsVisible(true)}
        disabled={loading}
      />
      <i
        onClick={() => !loading && setItemsVisible(!itemsVisible)}
        style={{ position: 'absolute', right: '5px', top: '4px' }}
        className={`icon-${itemsVisible ? 'up' : 'bottom'}`}
      />
      {itemsVisible && (
        <div
          style={{
            position: 'absolute',
            width: 200,
            maxHeight: 350,
            overflowY: 'auto',
          }}
        >
          <div className="contract-item" onClick={() => selectTenant(undefined)}>
            {t('ALL')}
          </div>
          {tenants.currentData
            ?.filter((t) => t.isCompany && (!search || t.name.toLowerCase().includes(search.toLowerCase())))
            .toSorted((a, b) => t.name.localeCompare(b.name))
            .map((t) => {
              return (
                <div className="contract-item" key={t.id} onClick={() => selectTenant(t)}>
                  {t.name}
                </div>
              )
            })}
        </div>
      )}
    </div>
  )
}
